'use client';

import { capture as posthogCapture } from './posthog';
import { pushAnalyticsEvent } from './google-tag-manager';

type DirectoryForm = 'booking' | 'claim' | 'lead_capture';

export function trackDirectoryFormStage(
  form: DirectoryForm,
  stage: 'viewed' | 'started' | 'submit_attempt',
  details: { listingId?: string; listingType?: string } = {},
) {
  const properties: Record<string, string> = {
    form,
    stage,
  };
  if (details.listingId) properties.listing_id = details.listingId;
  if (details.listingType) properties.listing_type = details.listingType;
  pushAnalyticsEvent('directory_form_stage', properties);
  posthogCapture('directory_form_stage', properties);
}

/** Form analytics intentionally excludes names, emails, messages and other PII. */
export function trackDirectoryFormSubmission(
  form: DirectoryForm,
  outcome: 'success' | 'failure',
  details: { listingId?: string; listingType?: string; reason?: string } = {},
) {
  const properties: Record<string, string> = {
    form,
    outcome,
  };
  if (details.listingId) properties.listing_id = details.listingId;
  if (details.listingType) properties.listing_type = details.listingType;
  if (details.reason) properties.reason = details.reason;
  pushAnalyticsEvent('directory_form_submission', properties);
  posthogCapture('directory_form_submission', properties);
}
